<div class="script">
    <div class="container">
        <div class="row mt-3">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb fqg f18">
                    <li class="mr-3">
                        <a href="/index"><img src="/assets/images/icon-yurt.png" alt="home"></a>
                    </li>
                    <li class="breadcrumb-item"><a href="/museum" class="mgl"> ᠮᠣᠩᠭᠣᠯ ᠨᠣᠮ ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠮᠦᠽᠧᠢ </a></li>
                    <li aria-current="page" class="breadcrumb-item active"><span class="mgl">{{tTitle}}</span></li>
                </ol>
            </nav>
        </div>
        <div class="row justify-content-center"><span class="col lpat"></span>
            <h4 class="col mgl catName justify-content-center fgq">{{tTitle}}</h4><span class="col lpat"></span></div>
        <ul id="pills-tab" role="tablist" class="nav nav-pills row justify-content-center classification pl-0 mb-4">
            <li class="nav-item col mb-3" *ngFor="let nl of nList;let i = index">
                <a class="nav-link mgl fgq f18 mx-auto mhover" [ngClass]="{'active': na === i}" (click)="navActive(nl.taxonomyId, i)">{{nl.taxonomyTitle}}</a>
            </li>
        </ul>
        <div class="bg-white rounded-lg">
            <div id="pills-tabContent" class="tab-content">
                <div id="script-1" role="tabpanel" aria-labelledby="script-1-tab" class="tab-pane fade show active">
                    <div class="row p-5 mb-5">
                        <div class="col-1 pt-4 pb-5">
                            <h4 class="mgl fgq f24 ml-0">{{wContent[0].title}}</h4>
                        </div>
                        <div class="col-11 pt-4 pb-4 pr-3">
                            <div class="simg">
                                <div class="simg_max">
                                    <img nz-image class="img_max_100 hp" nzSrc="{{url + aImage}}" alt="">
                                </div>
                                <div class="d-flex simg_min">
                                    <div class="sm_item hp" [ngClass]="{'si_active': ia === i}" *ngFor="let wi of wImages;let i = index">
                                        <img alt="" class="img_max_100" src="{{url + wi.path}}" (click)="iActive(i, wi.path)">
                                    </div>
                                </div>
                            </div>
                            <div class="col pl-0 pb-3 overflow-auto">
                                <div class="mgl fqg f18 mt-5 ml-0 mb-0 s_content">
                                    {{wContent[0].content}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>